import { Checkbox, CheckboxProps, FormControl, FormControlLabel, FormHelperText } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type TriggerByName = {
    trigger: Function;
    name: string;
};

export type SGSCheckboxProps = CheckboxProps & {
    error?: boolean;
    label?: string;
    helperText?: string;
    name?: string;
    handleChange?: Function;
    trigger?: Function;
    triggerByName?: TriggerByName | null;
    readOnly?: boolean;
};

const SGSCheckboxCtr: React.FC<SGSCheckboxProps> = ({ error, label, helperText, name, handleChange, trigger, triggerByName, readOnly = false, ...props }) => {
    const { t } = useTranslation();
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const errorPath = name.split('.');
    const errorMsg = errorPath.reduce((obj, key) => obj && obj[key], errors);

    return (
        <FormControl error={errorMsg ? true : false}>
            <Controller
                rules={{ required: true }}
                control={control}
                name={name}
                render={({ field }) => (
                    <>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    {...props}
                                    name={name}
                                    checked={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.checked);
                                    }}
                                />
                            }
                            label={typeof label === 'string' ? t(label) : label}
                            className="mb-0"
                        />

                        {helperText && <FormHelperText>{helperText}</FormHelperText>}
                    </>
                )}
            />
            {errorMsg?.message && <FormHelperText error>{errorMsg?.message}</FormHelperText>}
        </FormControl>
    );
};

export default SGSCheckboxCtr;
